<template>
  <div>
    <b-modal :active.sync="show" has-modal-card>
      <form action="">
        <div class="modal-card" style="width: auto">
          <header class="modal-card-head is-bg-primary">
            <p class="modal-card-title has-text-white">Transkrip <span v-if="!isEmpty(account)"> - {{ account.name }}</span></p>
          </header>
          <section class="modal-card-body">
            <b-table v-if="!isEmpty(data_transcript)" :data="data_transcript">
              <template slot-scope="props">
                <b-table-column field="namaMataKuliah" label="Mata Kuliah">
                  <p class="title" style="font-size: 15px;">{{ props.row.namaMataKuliah }}</p>
                  <p class="subtitle" style="font-size: 14px;">{{ props.row.kodeMataKuliah }}</p>
                </b-table-column>

                <b-table-column field="sks" label="SKS">
                  {{ props.row.sks || '-' }}
                </b-table-column>

                <b-table-column field="nilaiHuruf" label="Nilai">
                  {{ props.row.jadwal || '-' }}
                </b-table-column>
              </template>
            </b-table>
          </section>
          <footer class="modal-card-foot">
          </footer>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import { ACCOUNT } from '~/consts';

export default {
  props: {
    account: {
      type: Object,
      default: null
    },
    onHide: {
      type: Function,
      default: () => {}
    }
  },

  computed: {
    nim() {
      if (!this.isEmpty(this.account)) {
        return this.account.userUniversityId
      }

      return null;
    },
    data_transcript() {
      if (!this.isEmpty(this.transcript)) {
        return this.transcript.mataKuliah;
      }

      return [];
    },
    show: {
      get() {
        return !this.isEmpty(this.nim) ? true : false
      },
      set() {
        this.onHide();
      }
    }
  },

  watch: {
    account(val) {
      if (!this.isEmpty(val)) {
        this.getData()
      } else {
        this.transcript = [];
      }
    },
  },

  data() {
    return {
      transcript: [],
    }
  },

  methods: {
    getData() {
      const vm = this;

      this.$axios.post(ACCOUNT.GET_TRANSCRIPT(this.account.universityId), {
        isDefault: 0,
        user_university_id: this.nim
      }).then(({ data }) => {
        if (data.applicationSystem.code == 0) {
          vm.transcript = data.data;
        } else {
          this.$buefy.toast.open(data.applicationSystem.message);
        }
      }).catch(({ response }) => {
      })
    }
  }
}
</script>

<style>

</style>
